export const Divider=()=>{
    return(
        <>
            <hr className="grey"/>
        </>
    )
}